(async () => {
    const { Core } = await importModule('Core');
    const { $hover } = await importModule('Utils');

    customElements.define('main-navigation', class extends Core {
        elements = {
            dropdowns: '*[data-drop]'
        }
        render() {
            this.$dropdowns.map(this._handleDropdown.bind(this))
        }
        _handleDropdown(drop) {

            const NavigationList = this.querySelector('.main-navigation-list');
          const ScrollLeftBtn = this.querySelector('.menu-category__scroll-button--left');
          const ScrollRightBtn = this.querySelector('.menu-category__scroll-button--right');
          
          if(NavigationList) {

            function NavigationListScroll() {
                   let offsetWidth = Math.round(NavigationList.offsetWidth);
                    let scrollWidth = Math.round(NavigationList.scrollWidth);
                     let scrollLeft = Math.round(NavigationList.scrollLeft);
                      let scrollRight = scrollLeft + offsetWidth;

                       if(ScrollRightBtn && ScrollLeftBtn) {
                         console.log(scrollRight);
                          console.log(scrollWidth);
                     if(scrollRight == scrollWidth && scrollLeft != 0) {
             
                         ScrollRightBtn.classList.remove('active');
                         ScrollLeftBtn.classList.add('active');
                       } else if(scrollLeft == 0 &&  scrollWidth > offsetWidth) {
                    
                        ScrollRightBtn.classList.add('active');
                        ScrollLeftBtn.classList.remove('active');
                       } else if(scrollLeft > 0 && scrollRight < scrollWidth) {
               
                            ScrollRightBtn.classList.add('active');
                         ScrollLeftBtn.classList.add('active');
                       } else if(offsetWidth == scrollWidth) {
     
                          ScrollRightBtn.classList.remove('active');
                         ScrollLeftBtn.classList.remove('active');
                       }
                     }
            }
                   NavigationList.addEventListener('scroll', NavigationListScroll);
            NavigationListScroll();
            
            if(ScrollLeftBtn) {
              ScrollLeftBtn.addEventListener('click', function(e) {
                e.preventDefault();
                NavigationList.scrollTo({ left: 0, behavior: 'smooth'});
              });
            }
          if(ScrollRightBtn) {
              ScrollRightBtn.addEventListener('click', function(e) {
                e.preventDefault();
                NavigationList.scrollTo({ left: 99999, behavior: 'smooth'});
              });
            }
          }
          
            $hover(drop, (e, state) => this.publish('lights-out', state));
        }
    });
})();